export const breakPoints = {
    mobile: 700,
    tablet: 1000,
    tabletMedium: 1150,
    tabletLarge: 1200,
    desktop: 1400,
    desktopLarge: 1600,
    widescreen: 1800,
};
